import {useContext} from 'react';
import AddIcon from 'src/components/ui-icons/tests/AddIcon';
import {TestContext} from '../../store/testContext';
import {toggleQuestionFormOpen} from '../../store/testActions';
import TGButton from 'src/components/ui/TGButton';

export default function ButtonAddNewQuestion() {
  const {dispatch} = useContext(TestContext);

  const handleClick = () => {
    dispatch(toggleQuestionFormOpen(true));
  };

  return (
    <TGButton className="w-full" icon={<AddIcon />} onClick={handleClick}>
      Добавить вопрос
    </TGButton>
  );
}
